import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { SecurityRoleService } from '@app/modules/security-roles/services/security-role.service';
import { RoleType } from '@app/modules/security-setup/models/security-role.model';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-security-role-type-form-field',
  templateUrl: './security-role-type-form-field.component.html',
  styleUrls: ['./security-role-type-form-field.component.scss']
})
export class SecurityRoleTypeFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<RoleType[]>;

  constructor(
    private securityRoleService: SecurityRoleService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.securityRoleService.getRoleTypes())
  }
}
